class CircleBubble {

}

export default CircleBubble